// react
import { ReactNode } from 'react';

// types
import { Transaction } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// router
import { useSearchParams } from 'react-router-dom';

// mui
import { Grid, GridProps, Link, LinkProps, Typography } from '@mui/material';

// dialogs
import { DialogTransaction } from '../../dialogs/DialogTransaction/DialogTransaction';

// utils
import { translateTransactionType } from '../../../utils/translations';

// ui
import { IconCircleProps } from '../../ui/IconCircle/IconCircle';
import { IconCircleTransaction } from '../../ui/IconCircleTransaction/IconCircleTransaction';
import { TypographyCaption } from '../../ui/TypographyCaption/TypographyCaption';

// props
export interface LinkTransactionProps extends LinkProps {
	children?: ReactNode;
	GridProps?: GridProps;
	hasIconCircle?: boolean;
	IconCircleProps?: IconCircleProps;
	isStatic?: boolean;
	transaction?: Transaction;
	[x: string]: unknown;
}

export const LinkTransaction = ({
	account,
	children,
	GridProps,
	hasIconCircle = true,
	IconCircleProps = {},
	isStatic = false,
	transaction,
	...props
}: LinkTransactionProps) => {
	// hooks
	const [searchParams, setSearchParams] = useSearchParams();
	const { t } = useTranslation();

	// params
	const paramDialog = searchParams.get('dialog');
	const paramDialogTransaction = searchParams.get('dialogTransaction');

	// vars
	let content = children;

	if (transaction) {
		content = translateTransactionType(transaction?.type, t);
	}

	const handleOpenDialogTransaction = () => {
		if (transaction) {
			searchParams.set('dialog', 'transaction');
			searchParams.set('dialogTransaction', String(transaction.id));
			setSearchParams(searchParams);
		}
	};

	const handleCloseDialog = () => {
		searchParams.delete('dialog');
		searchParams.delete('dialogTransaction');
		setSearchParams(searchParams);
	};

	if (transaction) {
		let link: ReactNode = (
			<Link
				component="button"
				fontWeight={600}
				onClick={handleOpenDialogTransaction}
				sx={{ position: 'static', textAlign: 'left' }}
				underline="hover"
				{...props}>
				{content}
			</Link>
		);

		if (isStatic) {
			link = <Typography fontWeight={600}>{content}</Typography>;
		}

		return (
			<>
				<Grid alignItems="center" container spacing={1} wrap="nowrap" {...GridProps}>
					{hasIconCircle && (
						<Grid item>
							<IconCircleTransaction size="xs" transaction={transaction} {...IconCircleProps} />
						</Grid>
					)}
					<Grid item xs={true}>
						<Grid container>
							<Grid item xs={12}>
								<TypographyCaption id={transaction.id} />
							</Grid>
							<Grid item xs={12}>
								{link}
							</Grid>
						</Grid>
					</Grid>
				</Grid>
				<DialogTransaction
					isOpen={
						paramDialog === 'transaction' && paramDialogTransaction === String(transaction.id)
					}
					onClose={handleCloseDialog}
				/>
			</>
		);
	}

	return <Typography>{t('na')}</Typography>;
};
